/**
 * The Elayne API parser returns enriched fields as { value, citations } objects.
 * The default parser returns plain values. This utility normalizes both formats
 * by deeply unwrapping any { value, citations } objects to just the value.
 */
function isEnrichedField(val: unknown): val is { value: unknown; citations: unknown } {
  return typeof val === "object" && val !== null && "value" in val && "citations" in val;
}

export function unwrapExtraction<T>(data: T): T {
  if (data === null || data === undefined) return data;

  if (isEnrichedField(data)) {
    return unwrapExtraction(data.value) as T;
  }

  if (Array.isArray(data)) {
    return data.map((item) => unwrapExtraction(item)) as T;
  }

  if (typeof data === "object") {
    const result: Record<string, unknown> = {};
    for (const [key, val] of Object.entries(data as Record<string, unknown>)) {
      result[key] = unwrapExtraction(val);
    }
    return result as T;
  }

  return data;
}
